import { render, staticRenderFns } from "./DownloadExcel.vue?vue&type=template&id=2a0b42db&"
import script from "./DownloadExcel.vue?vue&type=script&lang=js&"
export * from "./DownloadExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports